import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginPublico, Ppa, Exercicio, ExercicioService, OrgaoService, PpaService, TransparenciaParametro, GlobalService, Coluna, Relatorio, FuncaoService, TransparenciaTituloDescricaoQuadro, TransparenciaInformacaoAdicionalGrupo } from 'eddydata-lib';
import { AcaoGovernoService, IndicadorService, MetaGovernoService } from 'administrativo-lib';
import { Anexo1Ppa, Anexo2Ppa, Anexo3Ppa, FonteFinanciamentoService } from 'contabil-lib';
import { TransparenciaParametroService } from '../../transparencia-parametro/service/transparencia-parametro.service';
import { MessageService } from 'primeng/api';
import { TransparenciaTituloDescricaoQuadroService } from '../../transparencia-titulo-descricao-quadro/service/transparencia-titulo-descricao-quadro.service';
import { TransparenciaInformacaoAdicionalGrupoService } from '../transparencia-informacao-adicional-form/service/transparencia-informacao-adicional-grupo.service';

@Component({
  selector: 'app-transparencia-informacao-adicional-view',
  templateUrl: './transparencia-informacao-adicional-view.component.html',
  styleUrls: ['./transparencia-informacao-adicional-view.component.css']
})
export class TransparenciaInformacaoAdicionalViewComponent implements OnInit, OnDestroy {
  public login: LoginPublico = new LoginPublico();
  protected unsubscribe: Subject<void> = new Subject();
  public parametro = new TransparenciaParametro();
  public orgaos: number[] = [];
  public titulos: TransparenciaTituloDescricaoQuadro;
  public lista: TransparenciaInformacaoAdicionalGrupo[] = [];

  constructor(
    protected messageService: MessageService,
    protected orgaoService: OrgaoService,
    protected paramServico: TransparenciaParametroService,
    protected tituloDescricaoService: TransparenciaTituloDescricaoQuadroService,
    protected transparenciaInformcaoAdicionalGrupoService: TransparenciaInformacaoAdicionalGrupoService,
  ) {

  }

  ngOnInit() {
    this.login = GlobalService.obterSessaoLogin();
    this.tituloDescricaoService.obter({ 'orgao.id': this.login.orgao.id, relations: 'orgao' }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.titulos = res;
      });

    this.transparenciaInformcaoAdicionalGrupoService.filtrar(1, -1, { 'orgao.id': this.login.orgao.id, 'itens.id$not_null': true, relations: 'orgao,itens' }).pipe(takeUntil(this.unsubscribe))
      .subscribe((res) => {
        this.lista = res.content as TransparenciaInformacaoAdicionalGrupo[];
      });

    window.scrollTo(0, 0);
    this.login.contraste = sessionStorage.getItem('contraste') === 'true';
    this.orgaos.push(this.login.orgao.id);

    this.paramServico.obterParametro(this.login.orgao.id).subscribe(res => {
      this.parametro = res;
      this.parametro.orgao = this.login.orgao;
      if (!res) {
        this.parametro = new TransparenciaParametro();
        this.parametro.receita = false;
        this.parametro.receita_extra = false;
        this.parametro.empenho = false;
        this.parametro.empenho_extra = false;
        this.parametro.empenho_resto = false;
        this.parametro.liquidacao = false;
        this.parametro.liquidacao_resto = false;
        this.parametro.pagamento = false;
        this.parametro.pagamento_extra = false;
        this.parametro.pagamento_resto = false;
        this.parametro.contrato = false;
        this.parametro.licitacao = false;
        this.parametro.repasse = false;
        this.parametro.convenio = false;
        this.parametro.equipamento = false;
        this.parametro.ata = false;
        this.parametro.remuneracao = false;
        this.parametro.transf_orgao = false;
        this.parametro.transf_federal = false;
        this.parametro.transf_estadual = false;
        this.parametro.arrecadacao_imposto = false;
        this.parametro.planejamento = false;
        this.parametro.conta_publica = false;
        this.parametro.operacao_credito = false;
        this.parametro.covid_receita = false;
        this.parametro.covid_despesa = false;
        this.parametro.operacao_credito = false;
        this.parametro.acumular_desconto_holerite = false;
        this.parametro.mostrar_relatorio_loa = false;
        this.parametro.plan_url = 'http://';
        this.parametro.esic_url = '';
        this.parametro.data_atualizacao = new Date();
      } else {
        this.parametro.data_atualizacao = new Date(res.data_atualizacao);
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  compareFn(c1: any, c2: any): boolean {
    return c1 && c2 && c1.id && c2.id ? c1.id === c2.id : c1 === c2;
  }

}
